module.exports = __webpack_public_path__ + "static/img/clothing_11.cc86fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_11.png
// module id = IMGy
// module chunks = 0